export default __webpack_public_path__ + "static/media/signaling_channel_phenotypes.34bd583f.png";